// API Configuration - uses environment variables with fallback to localhost
const baseURL = process.env.REACT_APP_API_URL || "http://localhost:8090";

export { baseURL };